const debtSale = {
  productDebtSoldScreen: {
    headerTitle: {
      advance: 'Varo Advance',
      lineOfCredit: 'Varo Line of Credit',
    },
  },
  summarySection: {
    error: {
      title: 'Something went wrong',
      message:
        "We couldn't load your sold account details. Please try again later.",
    },
  },
};

export default debtSale;
